import * as XLSX from 'xlsx';
import { formatNormalizedDateForDisplay } from './dateFormatters';

const resolveWarehouseName = (row, warehouses) =>
  row.almacen
  || warehouses.find((warehouse) => warehouse.id === row.idAlmacen)?.nombre
  || 'Sin almacen';

const resolveUserName = (row, users) =>
  row.usuarioCreador
  || users.find((user) => user.id === Number(row.idUsuarioCreador))?.nombre
  || 'Sin usuario';

const getPaletQuantity = (row, cajaPaletId) =>
  Number(row.paletsEntrada?.[cajaPaletId] ?? row.paletsEntrada?.[String(cajaPaletId)] ?? 0);

const buildExcelRow = (row, warehouses, users, cajasPalet) => {
  const paletsColumns = cajasPalet.reduce((columns, cajaPalet) => ({
    ...columns,
    [`Palets de ${cajaPalet.cajas} cajas`]: getPaletQuantity(row, cajaPalet.id),
  }), {});

  return {
    Codigo: row.codigo,
    Fecha: formatNormalizedDateForDisplay(row.fecha),
    'ID almacen': row.idAlmacen,
    Almacen: resolveWarehouseName(row, warehouses),
    'Creado por': resolveUserName(row, users),
    'Codigo variedad': String(row.idVariedad ?? ''),
    Variedad: row.variedad,
    'Kilos entrada': row.kilos,
    'Grupos de 4 palots': row.crucesPalots,
    'Peso palot (kg)': row.kilosPalot,
    'Peso caja (kg)': row.pesoCaja,
    ...paletsColumns,
    'Total palots': row.totalPalots,
    'Kg volcados': row.kilosVolcados,
    'Kg reales': row.kgReales,
    'Precalibrado (kg)': row.otrosCalibres,
    'Precalibrado (palots)': row.pOtrosCalibres,
    'Retorno (kg)': row.retorno,
    'Retorno (palots)': row.pRetorno,
    'Verde (kg)': row.verde,
    'Verde (palots)': row.pVerde,
    'Segunda (kg)': row.segunda,
    'Segunda (palots)': row.pSegunda,
    'Bajo calibre (kg)': row.bajoCalibre,
    'Bajo calibre (palots)': row.pBajoCalibre,
    'Industria (kg)': row.industria,
    'Industria (palots)': row.pIndustria,
    'Podrido (kg)': row.podrido,
    'Primera (kg)': row.primera,
    'Kg clasificados': row.kilosClasificados,
    'Kg sin clasificar': row.kilosSinClasificar,
    'Rendimiento (%)': row.rendimiento,
    'Primera (%)': row.porcentajePrimera,
    Observaciones: row.observaciones || '',
  };
};

const getColumnWidth = (header) => {
  if (header === 'Observaciones') return { wch: 40 };
  if (header === 'Variedad' || header === 'Creado por') return { wch: 22 };
  if (header === 'Almacen' || header === 'Fecha') return { wch: 15 };
  return { wch: Math.max(12, Math.min(header.length + 2, 24)) };
};

export const exportEntradasToExcel = (
  rows,
  { warehouses = [], users = [], cajasPalet = [] } = {}
) => {
  const excelRows = rows.map((row) => buildExcelRow(row, warehouses, users, cajasPalet));
  const worksheet = XLSX.utils.json_to_sheet(excelRows);
  const headers = Object.keys(excelRows[0] || {});

  worksheet['!cols'] = headers.map(getColumnWidth);
  worksheet['!autofilter'] = { ref: worksheet['!ref'] };
  worksheet['!freeze'] = { xSplit: 0, ySplit: 1 };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Entradas');

  const today = new Date();
  const dateSuffix = [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0'),
  ].join('-');

  XLSX.writeFile(workbook, `entradas_${dateSuffix}.xlsx`, { compression: true });
};
